import { Component, EventEmitter, Output } from "@angular/core";

@Component({
    template: "",
    standalone: false
})
export class DeckData {
    @Output()
    public requestDeckGroups: EventEmitter<DeckGroupDataRequest> = new EventEmitter();
}

export type DeckGroupDataRequest = (groups: string[]) => void;